"use strict";
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlanningItemCommentApi = exports.PlanningItemCommentApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
// @ts-ignore
const models_1 = require("../models");
/**
 * PlanningItemCommentApi - axios parameter creator
 * @export
 */
const PlanningItemCommentApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {number} planningItemId
         * @param {ICommentEntity} iCommentEntity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPlanningItemComment: async (planningItemId, iCommentEntity, options = {}) => {
            // verify required parameter 'planningItemId' is not null or undefined
            (0, common_1.assertParamExists)('addPlanningItemComment', 'planningItemId', planningItemId);
            // verify required parameter 'iCommentEntity' is not null or undefined
            (0, common_1.assertParamExists)('addPlanningItemComment', 'iCommentEntity', iCommentEntity);
            const localVarPath = `/api/planning-item/comment/add`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (planningItemId !== undefined) {
                localVarQueryParameter['planningItemId'] = planningItemId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iCommentEntity, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} planningItemId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlanningItemComments: async (planningItemId, options = {}) => {
            // verify required parameter 'planningItemId' is not null or undefined
            (0, common_1.assertParamExists)('listPlanningItemComments', 'planningItemId', planningItemId);
            const localVarPath = `/api/planning-item/comment/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // http bearer authentication if accessToken is configured
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (planningItemId !== undefined) {
                localVarQueryParameter['planningItemId'] = planningItemId;
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.PlanningItemCommentApiAxiosParamCreator = PlanningItemCommentApiAxiosParamCreator;
/**
 * PlanningItemCommentApi -
 */
var PlanningItemCommentApi;
(function (PlanningItemCommentApi) {
    /**
     *
     * @param {number} planningItemId
     * @param {ICommentEntity} iCommentEntity
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof PlanningItemCommentApi
     * url /api/planning-item/comment/add
     */
    async function addPlanningItemComment(planningItemId, iCommentEntity, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.PlanningItemCommentApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.addPlanningItemComment(planningItemId, iCommentEntity, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = (0, models_1.parseICommentEntity)(res.data);
            return res;
        });
    }
    PlanningItemCommentApi.addPlanningItemComment = addPlanningItemComment;
    /**
     *
     * @param {number} planningItemId
     * @param {*} [options] Override http request option.
     * @param {*} [configuration] Override the defaultConfiguration
     * @throws {RequiredError}
     * @memberof PlanningItemCommentApi
     * url /api/planning-item/comment/list
     */
    async function listPlanningItemComments(planningItemId, options, configuration = common_1.defaultConfiguration) {
        const localVarAxiosParamCreator = (0, exports.PlanningItemCommentApiAxiosParamCreator)(configuration);
        const localVarAxiosArgs = await localVarAxiosParamCreator.listPlanningItemComments(planningItemId, options);
        const axiosRequest = (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        return axiosRequest(axios_1.default, (0, common_1.getBasePath)(configuration))
            .then(res => {
            res.data = res.data.map((x) => (0, models_1.parseICommentEntity)(x));
            return res;
        });
    }
    PlanningItemCommentApi.listPlanningItemComments = listPlanningItemComments;
})(PlanningItemCommentApi || (exports.PlanningItemCommentApi = PlanningItemCommentApi = {}));
